import { useEffect } from 'react';

export type ToastKind = 'info' | 'success' | 'error';

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  text: string;
}

interface ToastProps {
  toast: ToastMessage;
  onDismiss: (id: number) => void;
}

export function Toast({ toast, onDismiss }: ToastProps) {
  useEffect(() => {
    const handle = window.setTimeout(() => onDismiss(toast.id), toast.kind === 'error' ? 5000 : 3000);
    return () => window.clearTimeout(handle);
  }, [toast.id, toast.kind, onDismiss]);

  const tone =
    toast.kind === 'success'
      ? 'border-emerald-500/40 text-emerald-200 bg-emerald-500/10'
      : toast.kind === 'error'
        ? 'border-rose-500/40 text-rose-200 bg-rose-500/10'
        : 'border-zinc-500/40 text-zinc-100 bg-zinc-500/10';

  return (
    <div
      role="status"
      className={`pointer-events-auto rounded-lg border px-3 py-2 text-sm shadow-lg backdrop-blur-sm ${tone}`}
    >
      {toast.text}
    </div>
  );
}

interface ToastStackProps {
  toasts: ToastMessage[];
  onDismiss: (id: number) => void;
}

export function ToastStack({ toasts, onDismiss }: ToastStackProps) {
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <Toast key={t.id} toast={t} onDismiss={onDismiss} />
      ))}
    </div>
  );
}
